module.exports = __webpack_public_path__ + "static/media/our-audience.9bcc7150.svg";